import { useEffect, useRef } from "react";
import { useReducedMotion, useIsTouch } from "../hooks/useReducedMotion";

export const Cursor = () => {
  const dotRef = useRef(null);
  const reduced = useReducedMotion();
  const touch = useIsTouch();

  useEffect(() => {
    if (reduced || touch) return;
    const dot = dotRef.current;
    if (!dot) return;

    const move = (e) => {
      dot.style.transform = `translate3d(${e.clientX}px, ${e.clientY}px, 0) translate(-50%, -50%)`;
    };
    const enter = (e) => {
      const ti = e.target.closest("input, textarea, [data-text-cursor]");
      if (ti) dot.classList.add("is-text");
    };
    const leave = (e) => {
      if (!e.relatedTarget) return;
      dot.classList.remove("is-text");
    };
    const out = () => { dot.classList.add("is-hidden"); };
    const in_ = () => { dot.classList.remove("is-hidden"); };

    window.addEventListener("mousemove", move);
    document.addEventListener("mouseover", enter);
    document.addEventListener("mouseout", leave);
    document.addEventListener("mouseleave", out);
    document.addEventListener("mouseenter", in_);
    return () => {
      window.removeEventListener("mousemove", move);
      document.removeEventListener("mouseover", enter);
      document.removeEventListener("mouseout", leave);
      document.removeEventListener("mouseleave", out);
      document.removeEventListener("mouseenter", in_);
    };
  }, [reduced, touch]);

  if (reduced || touch) return null;
  return <div className="cursor-dot" ref={dotRef} data-testid="custom-cursor-dot" />;
};
